import axios from 'axios';
import { isNil } from 'lodash';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import env from 'utils/env';
import { setItem, removeItem, getSiteCode } from 'utils/local-storage';
import { ACCESS_TOKEN, DISCOUNT_CODE, URL_QUERY_STRING, USER_PROFILE } from 'utils/storage-keys';

const SESSION_KEY = 'sessionToken';
const SESSION_KEY_EXPIRY = 'sessionTokenExpiry';

declare const window : any

export const loadSession = () => {
  const sessionToken = localStorage.getItem(SESSION_KEY);
  const sessionTokenExpiry = localStorage.getItem(SESSION_KEY_EXPIRY);

  if (isNil(sessionToken)) {
    return null;
  }

  if (isNil(sessionTokenExpiry)) {
    removeItem(SESSION_KEY);
    removeItem(SESSION_KEY_EXPIRY);
    removeItem(ACCESS_TOKEN);
    removeItem(USER_PROFILE);
    return null;
  }

  const expiredDate = Number.parseInt(sessionTokenExpiry.toString(), 10);
  if (expiredDate <= Date.now()) {
    removeItem(SESSION_KEY);
    removeItem(SESSION_KEY_EXPIRY);
    removeItem(ACCESS_TOKEN);
    removeItem(USER_PROFILE);
    return null;
  }

  return sessionToken;
};

const useSession = () => {
  const [session, setSession] = React.useState<string | null>(null);
  const [bootstrap, setBootstrap] = React.useState<boolean>(true);
  const navigate = useNavigate();
  const siteCode = getSiteCode();

  React.useEffect(() => {
    const sessionToken = loadSession();
    setBootstrap(false);
    setSession(sessionToken);
  }, []);

  React.useEffect(()=> {
    async function getDiscountCode() {
      const config = env();
      const { data } = await axios.get(`${config.userServerApiUrl}/product-catalog/v1/site/${siteCode}/paywall?country=TW`);
      if (data?.name) {
        setItem(DISCOUNT_CODE, data.name + 'TW');
      } else {
        setItem(DISCOUNT_CODE, 'TWTELTW');
      }
    }
    getDiscountCode();
  }, [siteCode]);

  const storeSession = React.useCallback(
    (sessionToken: string, expiry: Date) => {
      setItem(SESSION_KEY, sessionToken);
      setItem(SESSION_KEY_EXPIRY, expiry.getTime().toString());

      setSession(sessionToken);
    },
    []
  );

  const signOut = () => {
    removeItem(SESSION_KEY);
    removeItem(ACCESS_TOKEN);
    removeItem(URL_QUERY_STRING);
    removeItem(USER_PROFILE);
    setSession(null);
    navigate('/login');
    window.location.reload();
  };

  return {
    session,
    bootstrap,
    storeSession,
    signOut
  };
};

export default useSession;
